// extracted by mini-css-extract-plugin
export default {"link":"sidebar_link__zuzoH","openTab":"sidebar_openTab__MBT1D"};